module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "pagebody"
  }, [(_vm.title) ? _c('header', [_c('h1', {
    staticClass: "h6plus",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.body) ? _c('section', {
    staticClass: "textbody h6plus",
    class: {
      'nimbus-sans': _vm.fontStyle === 'sans-serif'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.body)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('footer', {
    staticClass: "underline-links"
  }, [(_vm.footHead) ? _c('h2', {
    staticClass: "pagebody__header h6plus",
    domProps: {
      "innerHTML": _vm._s(_vm.footHead)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.footBody) ? _c('section', {
    staticClass: "contact h7 nimbus-sans",
    domProps: {
      "innerHTML": _vm._s(_vm.footBody)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCredits) ? _c('credits', {
    staticClass: "is-hidden-mobile"
  }) : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-385f3d9d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageBody.vue
// module id = 380
// module chunks = 1